module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "template template--sidebar"
  }, [_c('achievement'), _c('sidebar-workspace', {
    attrs: {
      "user": _vm.loggedInUser,
      "group": _vm.currentGroup,
      "loadingUserProgress": false
    }
  }), _c('div', {
    staticClass: "page-wrap"
  }, [_c('transition', {
    attrs: {
      "name": "view-transition",
      "mode": "out-in"
    },
    on: {
      "after-leave": _vm.afterPageViewLeave
    }
  }, [_c('router-view', {
    key: _vm.viewKey,
    staticClass: "page-view",
    attrs: {
      "loading": false,
      "user": _vm.loggedInUser,
      "group": _vm.currentGroup
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b19a209","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/WorkspaceManager.vue
// module id = G6Uf
// module chunks = 1